export const calculateEvaluationAverage = (
    teamwork: number,
    client_relationship: number,
    autonomy: number,
    critical_thinking: number
) => {
    const average = (teamwork + client_relationship + autonomy + critical_thinking) / 4;
    return average.toFixed(2);
};
